/**
 * Pure Scentum — shared scroll-reveal.
 * Fades/slides in any element with class "ps-reveal" (or "[data-ps-reveal-group] > *")
 * as it enters the viewport. Include once per page (safe to include in every
 * section too — it no-ops after the first run).
 */
(function () {
  if (window.__psRevealInit) return;
  window.__psRevealInit = true;

  function run() {
    var targets = Array.prototype.slice.call(document.querySelectorAll('.ps-reveal'));
    if (!targets.length) return;

    // Optional staggered delay for groups: add data-ps-reveal-stagger="110" on the parent.
    document.querySelectorAll('[data-ps-reveal-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-ps-reveal-stagger'), 10) || 100;
      var children = Array.prototype.slice.call(group.querySelectorAll('.ps-reveal'));
      children.forEach(function (el, i) {
        el.style.transitionDelay = (i * step) + 'ms';
      });
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });

    // Safety net: a section that Shopify's theme editor mounts off-screen
    // (or a slow layout shift) should never stay permanently hidden.
    var sweep = function () {
      var vh = window.innerHeight;
      targets.forEach(function (el) {
        if (el.classList.contains('is-visible')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) el.classList.add('is-visible');
      });
    };
    setTimeout(sweep, 2500);
    setTimeout(function () { targets.forEach(function (el) { el.classList.add('is-visible'); }); }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-scan when the theme editor injects/re-renders a section.
  document.addEventListener('shopify:section:load', function () {
    window.__psRevealInit = false;
    window.__psRevealInit = true;
    run();
  });
})();
